import { MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';

// Dialog constants
export const dialogConfig: MatDialogConfig = {
  data: null,
  position: {
    top: '100px'
  }
};
export const dialogSize300 = '300px';
export const dialogSize400 = '400px';
export const dialogSize450 = '450px';
export const dialogSize550 = '550px';
export const dialogSize600 = '600px';
export const dialogSize800 = '800px';

// SnackBar constants
export const snackBarConfig: MatSnackBarConfig<any> = {
  duration: 3000,
  verticalPosition: 'top',
  horizontalPosition: 'right'
};

// RxJs constants
export const debounceTimeMilliseconds = 500;

// login
export const loginForm = 'login';
export const resetPasswordForm = 'reset-password';
export const rememberMeLogin = 'remember_me';

// Password constraints
export const PASSWORD_MAX_LENGTH = 128;

// forgot passowrd
export const emailForm = 'email';
export const newPasswordForm = 'new-password';

// Pagination constants
export const pageSizeOptions: number[] = [5, 10, 25];
export const pageSize = 10;

// Role constants
export const roleStaff = 'STAFF';
export const localizationRead = 'LOCALIZATION_READ';
export const localizationModify = 'LOCALIZATION_MODIFY';
export const staffRead = 'STAFF_READ';
export const staffModify = 'STAFF_MODIFY';
export const clientRead = 'CLIENT_READ';
export const clientModify = 'CLIENT_MODIFY';
export const configRead = 'CONFIG_READ';
export const configModify = 'CONFIG_MODIFY';
export const messageRead = 'MESSAGE_READ';
export const messageModify = 'MESSAGE_MODIFY';
export const roleRead = 'ROLE_READ';
export const roleModify = 'ROLE_MODIFY';
export const paymentModify = 'PAYMENT_MODIFY';
export const paymentRead = 'PAYMENT_READ';
export const kycRead = 'KYC_READ';
export const kycModify = 'KYC_MODIFY';
export const auditLogRead = 'AUDIT_LOG_READ';

export const userCanModify = 'STAFF_MODIFY';
export const systemAdmin = 'ROLE_SYSTEM_ADMIN';

// User statuses
export const tableLabels = {
  ACTIVE: {
    textClass: 'text-green',
    bgClass: 'bg-green-light',
    previewClass: 'bg-green'
  },
  SUSPENDED: {
    textClass: 'text-red',
    bgClass: 'bg-red-light',
    previewClass: 'bg-red'
  },
  REGISTERED: {
    textClass: 'text-purple',
    bgClass: 'bg-purple-light',
    previewClass: 'bg-purple'
  },
  APPROVED: {
    textClass: 'text-green',
    bgClass: 'bg-green-light',
    previewClass: 'bg-green'
  },
  REJECTED: {
    textClass: 'text-red',
    bgClass: 'bg-red-light',
    previewClass: 'bg-red'
  },
  INVALID: {
    textClass: 'text-red',
    bgClass: 'bg-red-light',
    previewClass: 'bg-red'
  },
  UNDEFINED: {
    textClass: 'text-red',
    bgClass: 'bg-red-light',
    previewClass: 'bg-red'
  },
  PENDING: {
    textClass: 'text-purple',
    bgClass: 'bg-purple-light',
    previewClass: 'bg-purple'
  },
  WAITING_FOR_DOCUMENTATION: {
    textClass: 'text-orange',
    bgClass: 'bg-orange-light',
    previewClass: 'bg-orange'
  },
  DELETED: {
    textClass: 'text-red',
    bgClass: 'bg-red-light',
    previewClass: 'bg-red'
  },
  CANCELED: {
    textClass: 'text-red',
    bgClass: 'bg-red-light',
    previewClass: 'bg-red'
  },
  COMPLETED: {
    textClass: 'text-green',
    bgClass: 'bg-green-light',
    previewClass: 'bg-green'
  },
  CONFIRMED: {
    textClass: 'text-orange',
    bgClass: 'bg-orange-light',
    previewClass: 'bg-orange'
  },
  FAILED: {
    textClass: 'text-red',
    bgClass: 'bg-red-light',
    previewClass: 'bg-red'
  },
  NEW_REQUEST: {
    textClass: 'text-orange',
    bgClass: 'bg-orange-light',
    previewClass: 'bg-orange'
  },
  IN_PROGRESS: {
    textClass: 'text-orange',
    bgClass: 'bg-orange-light',
    previewClass: 'bg-orange'
  },
  CANCELLED: {
    textClass: 'text-red',
    bgClass: 'bg-red-light',
    previewClass: 'bg-red'
  },
  DEFAULT: {
    textClass: 'text-red',
    bgClass: 'bg-red-light',
    previewClass: 'bg-red'
  },
  ONGOING: {
    textClass: 'text-orange',
    bgClass: 'bg-orange-light',
    previewClass: 'bg-orange'
  }
};

// filter
export const tableFilterDefaults = {
  page: 0,
  size: pageSize,
  sort: 'id,desc'
};

// property
export const configDefaultLang = 'aument.config.default.lang';

// errors

export const passChageRequired = 'pass_change_required';
export const twoFaRequired = 'two_fa_required';

// notifications
export const success = 'notifications.success';
export const errorType = 'notifications.error';
export const clientAdded = 'notifications.clientAdded';
export const clientUpdated = 'notifications.clientUpdated';
export const clientStatusChanged = 'notifications.clientStatusChanged';
export const clientDeleted = 'notifications.clientDeleted';
export const clientDeletionError = 'notifications.clientDeletionError';
export const propertyAdded = 'notifications.propertyAdded';
export const propertyUpdated = 'notifications.propertyUpdated';
export const propertyDeleted = 'notifications.propertyDeleted';
export const checkEmail = 'notifications.checkEmail';
export const passwordUpdated = 'notifications.passwordUpdated';
export const userUpdated = 'notifications.userUpdated';
export const userAdded = 'notifications.userAdded';
export const userStatusChanged = 'notifications.userStatusChanged';
export const photoLoadFailed = 'notifications.photoLoadFailed';
export const photoUpdated = 'notifications.photoUpdated';
export const successfullyChangedTfa = 'notifications.successfullyChangedTfa';
export const twoFaAuthentication = 'notifications.twoFaAuthentication';
export const roleAdded = 'notifications.roleAdded';
export const roleUpdated = 'notifications.roleUpdated';
export const localizationAdded = 'notifications.roleAdded';
export const localizationUpdated = 'notifications.localizationUpdated';
export const deviceUpdated = 'notifications.deviceUpdated';
export const localizationDeleted = 'notifications.localizationDeleted';
export const kycStatusChanged = 'notifications.kycStatusChanged';
export const kycDataChanged = 'notifications.kycDataChanged';
export const bankTransferUpdated = 'notifications.bankTransferUpdated';
export const requestLoanUpdated = 'notifications.requestLoanUpdated';
export const errorDeletedKYC = 'notifications.errorDeletedKYC';
export const emptyChat = 'notifications.emptyChat';
export const invalidFileType = 'notifications.invalidFileType';
export const fileTooLarge = 'notifications.fileTooLarge';
export const tooManyFiles = 'notifications.tooManyFiles';
export const maxAttachments = 20;
